import React from "react";

const SendMsgBtn = ({ theme }) => (
  <div className="w-[400px] h-[60px] flex justify-center items-center overflow-hidden">
    <button
      className={`${
        theme === "dark"
          ? "border-blue-800 text-lightBgColor"
          : "border-lightTextDesignColor text-darkBgColor"
      } font-titleFont text-xl  transition-hover relative duration-300 font-semibold w-[394px] h-14 border-[1px] group`}
    >
      Send Message
      <span
        className={`${
          theme === "dark" ? "bg-blue-800" : "bg-lightTextDesignColor"
        } absolute w-20 h-1 -left-1 -top-1 -translate-x-[81px] group-hover:translate-x-0 transition-all duration-500`}
      ></span>
      <span
        className={`${
          theme === "dark" ? "bg-blue-800" : "bg-lightTextDesignColor"
        } absolute w-1 h-8 -top-1 -left-1 -translate-y-[31px] group-hover:translate-y-0 transition-all duration-200`}
      ></span>
      <span
        className={`${
          theme === "dark" ? "bg-blue-800" : "bg-lightTextDesignColor"
        } absolute w-20 h-1 -right-1 -bottom-1 translate-x-[81px] group-hover:translate-x-0 transition-all duration-500`}
      ></span>
      <span
        className={`${
          theme === "dark" ? "bg-blue-800" : "bg-lightTextDesignColor"
        } absolute w-1 h-8 bg-darkBgColor -bottom-1 -right-1 translate-y-[31px] group-hover:translate-y-0 transition-all duration-200`}
      ></span>
    </button>
  </div>
);

export default SendMsgBtn;
